export default __webpack_public_path__ + "static/media/razer-headphone.fe49ce1e.png";